import { LoanApplicationService } from "../../../services/LoanApplication";

export const getTasksList = async (
  token: string,
  pageName: string,
  currentStage: string,
  taskId: string,
  workflowInstanceId: string
) => {
  const response: any = await LoanApplicationService.getTaskList({
    token,
    pageName,
    currentStage,
    taskId,
    workflowInstanceId
  });

  return response;
};

export const getWorkflowAction = async (
  rowData: any,
  loanDetails: any,
  isLenderPlatform: boolean
) => {
  const response: any = await LoanApplicationService.getWorkflowReqData({
    token: loanDetails?.token,
    pageName: loanDetails?.pageName as string,
    currentStage: rowData?.workflow_current_state as string,
    taskId: rowData?.task_id as string,
    workflowInstanceId: rowData?.workflow_instance_id as string,
    isLenderPlatform,
    loanApplicationID: loanDetails?.loanApplicationID,
    ...(!isLenderPlatform && {
      sourceEntityId: loanDetails?.sourceEntityID as string
    })
  });

  return response;
};

export const getCurrentStageTaskIDWorkflowInstanceId = async (
  configResponse: any,
  loanDetails: any,
  isLenderPlatform: boolean
) => {
  const tasksList = await getTasksList(
    loanDetails?.token,
    loanDetails?.pageName as string,
    rowData?.workflow_current_state!,
    rowData?.task_id!,
    rowData?.workflow_instance_id!
  );

  const workflowActions = await getWorkflowAction(
    rowData,
    loanDetails,
    isLenderPlatform
  );

  const currentStage = configResponse?.data?.currentStage;
  const taskId = configResponse?.data?.taskId;
  const workflowInstanceId = configResponse?.data?.workflowInstanceId;

  return { currentStage, taskId, workflowInstanceId };
};

export const onConfirm = async (
  loanApplicationID: string,
  selectedStage: string,
  remarks: string,
  workflowInstanceId: string,
  token: string,
  pageName: string,
  rejectionReason: string,
  subRejectionReason?: string,
  isLenderDashboard?: boolean,
  sourceEntityId?: string,
  userID?: string,
  isHERO_FINCORP?: boolean
) => {
  const response = await LoanApplicationService.addWorkflowReqData({
    token,
    pageName,
    payload: {
      loanApplicationId: loanApplicationID,
      action: selectedStage || "",
      remarks,
      workflowInstanceId: workflowInstanceId,
      identifier_type: isHERO_FINCORP ? "USER_ID" : "LOAN_APPLICATION_ID",
      identifier_id: isHERO_FINCORP ? userID : loanApplicationID,
      event: "update_task",
      ...(rejectionReason && {
        additional_data: {
          task: {
            metadata: {
              rejectReason: rejectionReason,
              ...(subRejectionReason && { subRejectionReason })
            }
          }
        }
      })
    },
    isLenderDashboard,
    sourceEntityId
  });

  return response;
};
